import type { AccountRequest } from '@/types/api/events/allocation-update'
import type { AllocationUpdateEventMessage } from '@/types/api/events/trading-event'

export function getAccountRequestsFromAllocation(
  allocationUpdate: AllocationUpdateEventMessage,
): AccountRequest[] {
  return allocationUpdate.summary?.account_requests ?? []
}
